module.exports = "pegasus/assets/circleline-snapchat.png";